import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { Form, Input, message } from 'antd';
import { ReloadOutlined, SafetyOutlined } from '@ant-design/icons';
import request from '@/utils/request';

interface CaptchaChallenge {
  id: string;
  svg: string;
}

export interface CaptchaFieldHandle {
  /** Current captcha id to submit with the login/register call. null while loading. */
  getId: () => string | null;
  /** Force a refresh (call this after any auth failure — server consumed the old one). */
  refresh: () => void;
}

const CaptchaField = forwardRef<CaptchaFieldHandle>(function CaptchaField(_, ref) {
  const [captcha, setCaptcha] = useState<CaptchaChallenge | null>(null);

  const refresh = useCallback(async () => {
    try {
      const res = await request.get<CaptchaChallenge>('/auth/captcha');
      setCaptcha(res.data as unknown as CaptchaChallenge);
    } catch {
      message.error('验证码加载失败，请刷新页面');
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useImperativeHandle(ref, () => ({
    getId: () => captcha?.id ?? null,
    refresh,
  }));

  return (
    <Form.Item name="captchaAnswer" label="验证码" rules={[{ required: true, message: '请输入验证码' }]}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'stretch' }}>
        <Input
          size="large"
          prefix={<SafetyOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder="4 位验证码"
          maxLength={4}
        />
        <div
          onClick={refresh}
          title="点击刷新"
          style={{
            width: 140,
            flexShrink: 0,
            border: '1px solid #d9d9d9',
            borderRadius: 8,
            overflow: 'hidden',
            cursor: 'pointer',
            background: '#f4efe3',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {captcha ? (
            <div
              dangerouslySetInnerHTML={{ __html: captcha.svg }}
              style={{ display: 'flex', alignItems: 'center', height: '100%' }}
            />
          ) : (
            <ReloadOutlined style={{ color: '#bfbfbf' }} />
          )}
        </div>
      </div>
    </Form.Item>
  );
});

export default CaptchaField;
